(function () {
  const STORAGE_KEY = 'drfels_chat_card_dismissed';

  function buildCard() {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    const card = document.createElement('div');
    card.id = 'drfels-chat-card';
    card.setAttribute('role', 'complementary');
    card.setAttribute('aria-label', 'Chat with Dr. Fel\'s Naturals support');

    card.innerHTML = `
      <div id="drfels-chat-card-header">
        <div id="drfels-chat-avatar">${window.drfelsChatLogo ? `<img src="${window.drfelsChatLogo}" alt="Dr. Fel's Naturals" style="width:100%;height:100%;object-fit:cover;border-radius:50%;display:block;">` : '🌿'}</div>
        <div id="drfels-chat-info">
          <div id="drfels-chat-name">Dr. Fel's Naturals</div>
          <div id="drfels-chat-status">
            <div id="drfels-chat-dot"></div>
            <span id="drfels-chat-status-text">Online &bull; Replies in minutes</span>
          </div>
        </div>
        <button id="drfels-chat-close" aria-label="Dismiss chat prompt">&times;</button>
      </div>
      <div id="drfels-chat-body">
        <p id="drfels-chat-message">
          👋 Hi there! Have a question about our natural products? We're happy to help.
        </p>
        <div id="drfels-chat-cta">
          <span id="drfels-chat-cta-text">Start a conversation</span>
          <span id="drfels-chat-cta-arrow">→</span>
        </div>
      </div>
    `;

    document.body.appendChild(card);

    let fired = false;

    function dismiss() {
      card.classList.add('closing');
      sessionStorage.setItem(STORAGE_KEY, '1');
      setTimeout(() => card.remove(), 300);
    }

    function openChat() {
      if (fired) return;
      fired = true;

      const selectors = [
        'shopify-chat button',
        '#shopify-chat button',
        '[data-testid="chat-icon-button"]',
        'shopify-chat [role="button"]',
      ];
      for (const sel of selectors) {
        const btn = /** @type {HTMLElement|null} */ (document.querySelector(sel));
        if (btn) { btn.click(); break; }
      }

      dismiss();
    }

    card.addEventListener('click', openChat);

    const closeBtn = document.getElementById('drfels-chat-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (/** @type {MouseEvent} */ e) {
        e.stopPropagation();
        dismiss();
      });
    }

    setTimeout(() => {
      if (document.getElementById('drfels-chat-card')) dismiss();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(buildCard, 1800));
  } else {
    setTimeout(buildCard, 1800);
  }
})();
